import { Product } from './product.model';

export class Feedback{
    id?: string;
    type: string;
    details: string;
    product?: Product;
    createdBy: string;
}